 
// import { useNavigate } from "react-router-dom";
// import { useState } from "react";

// function MyItemCard({ item, type, onRefresh }) {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
  
//   // 🔥 Evidence Modal State
//   const [showEvidenceModal, setShowEvidenceModal] = useState(false);

//   /* ---------------- AUTH ---------------- */
//   const user = JSON.parse(localStorage.getItem("user"));
//   const myId = user?._id;
//    const isOwner = item?.owner?._id === myId || item?.owner === myId;

//  // Ye line add kar:
// const isBorrower = item?.borrowedBy?._id === myId || item?.borrowedBy === myId;
//   const token = localStorage.getItem("token");

//   if (!item) return null;

//   // 🔥 Evidence Data Extraction
//   const evidence = item.pickupEvidence || item.borrow?.pickupEvidence || [];

//   const activeBorrower = item.borrowedBy || item.borrower;

//   const coverImage =
//     item.images?.find((img) => img.isCover)?.url ||
//     item.images?.[0]?.url ||
//     "https://via.placeholder.com/300x180";

//   const formatDate = (d) =>
//     d ? new Date(d).toLocaleDateString("en-GB", { day: 'numeric', month: 'short' }) : "N/A";

//   // Court / Penalty Details
//   const court = item.adminCourt || {};
//   const mandateAmt = item.mandate?.maxDeductibleAmount || 0;

//   /* ==================================================
//        🔥 STATUS TRACKER (UPDATED FOR COURT)
//   ================================================== */
//   const renderStatusTracker = () => {
//     // 1. Agar Court Case Open hai
//     if (item.status === "disputed_in_court") {
//       return (
//         <div className="alert alert-danger p-1 mb-1 shadow-sm text-center flex-shrink-0" style={{ fontSize: "10px" }}>
//           <strong>⚖️ ADMIN COURT ACTIVE</strong>
//         </div>
//       );
//     }
//     // 2. Agar Case Khatam aur Penalty Lagi (Guilty)
//     if (court.verdict === "guilty") {
//       return (
//         <div className="alert alert-success p-1 mb-1 shadow-sm text-center flex-shrink-0" style={{ fontSize: "10px" }}>
//           <strong>💰 PENALTY APPROVED</strong>
//         </div>
//       );
//     }
//     // 3. Agar Case Dismiss hua (Innocent)
//     if (court.verdict === "innocent") {
//       return (
//         <div className="alert alert-secondary p-1 mb-1 shadow-sm text-center flex-shrink-0" style={{ fontSize: "10px" }}>
//           <strong>🕊️ CASE DISMISSED</strong>
//         </div>
//       );
//     }
//     return null;
//   };

//   /* ==================================================
//        🚨 REPORT THEFT (FILE CASE)
//   ================================================== */
//   const handleReportTheft = async (e) => {
//     e.stopPropagation();
//     const reason = prompt("🚨 FILE A CASE\n\nDescribe the issue (e.g., Theft, Damage, No Response):");
//     if (!reason) return;

//     if(!window.confirm("Are you sure? This will escalate the matter to Admin Court.")) return;

//     setLoading(true);
//     try {
//       const res = await fetch("https://borrowhub-backend.onrender.com/api/admin/file-case", {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
//         body: JSON.stringify({ itemId: item._id, reason })
//       });
//       const data = await res.json();
//       alert(data.message || "Case Filed!");
//       window.location.reload();
//     } catch (error) {
//       alert("Server Error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ==================================================
//        🔄 RETURN LOGIC (NORMAL FLOW)
//   ================================================== */
//   const handleReturn = async (e) => {
//     e.stopPropagation();
//     if (!window.confirm("Generate Return OTP?")) return;
//     setLoading(true);
//     try {
//       const res = await fetch("https://borrowhub-backend.onrender.com/api/return/request", {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//         body: JSON.stringify({ itemId: item._id })
//       });
//       const data = await res.json();
//       if (data.success) alert(`✅ OTP: ${data.otp}`);
//       else alert(data.message);
//     } catch { alert("Error"); }
//     setLoading(false);
//   };

//   return (
//     <>
//     <div
//       className="card shadow-sm h-100 border-0 mx-auto"
//       style={{ width: "100%", maxWidth: "280px", cursor: "pointer", overflow: "hidden" }}
//       onClick={() => navigate(`/items/${item._id}`)}
//     >
//       {/* TOP BADGES */}
//       {type === "lent" && isOwner && (
//         <div className="bg-dark text-white text-center py-1 fw-bold w-100 position-absolute" style={{ zIndex: 2, fontSize: "10px" }}>📤 LENT OUT</div>
//       )}
//       {type === "borrowed" && !isOwner && (
//         <div className="bg-success text-white text-center py-1 fw-bold w-100 position-absolute" style={{ zIndex: 2, fontSize: "10px" }}>📥 BORROWED</div>
//       )}

//       {/* IMAGE */}
//       <div style={{ position: "relative", height: "160px", backgroundColor: "#fff", marginTop: (type === 'lent' || type === 'borrowed') ? '22px' : '0' }}>
//         <img
//           src={coverImage}
//           style={{ width: "100%", height: "100%", objectFit: "contain" }}
//           alt={item.title}
//           className="p-2"
//         />
//         {/* Status Badge Over Image */}
//         {item.status === "disputed_in_court" && (
//             <div className="position-absolute bottom-0 w-100 bg-danger text-white text-center small fw-bold py-1" style={{fontSize: "10px"}}>
//                ⚖️ CASE ID: #{item._id.slice(-4)}
//             </div>
//         )}
//       </div>

//       {/* CARD BODY */}
//       <div className="card-body d-flex flex-column p-2">
//         <h6 className="fw-bold text-truncate mb-1" style={{ fontSize: "14px" }}>{item.title}</h6>
//         <div className="mb-2">
//           <span className="badge bg-light border text-secondary" style={{ fontSize: "10px" }}>{item.category}</span>
//         </div>

//         {renderStatusTracker()}

//         {/* -----------------------------------------------
//              🔥 COURT NOTICE SECTION (The Better Plan)
//         ----------------------------------------------- */}
        
//         {/* SCENARIO A: LENDER (Money Coming) 🎉 */}
//         {isOwner && court.verdict === "guilty" && (
//             <div className="alert alert-success p-1 mb-2" style={{fontSize: "11px"}}>
//                 <strong>💰 Payout Approved!</strong><br/>
//                 Admin executed penalty.<br/>
//                 You will receive: <b>₹{mandateAmt}</b>
//             </div>
//         )}

//         {/* SCENARIO B: BORROWER (Red Alert) 🚨 */}
//         {!isOwner && item.status === "disputed_in_court" && (
//             <div className="alert alert-danger p-1 mb-2" style={{fontSize: "11px"}}>
//                 <strong>🚨 COURT NOTICE</strong><br/>
//                 Owner reported theft.<br/>
//                 Contact Admin or <b>₹{mandateAmt}</b> will be deducted.
//             </div>
//         )}

//         {/* SCENARIO C: LENDER (Investigation) ⏳ */}
//         {isOwner && item.status === "disputed_in_court" && (
//              <div className="alert alert-warning p-1 mb-2" style={{fontSize: "11px"}}>
//                 <strong>⏳ Investigation On</strong><br/>
//                 Admin is reviewing case.<br/>
//                 Borrower notified.
//             </div>
//         )}


//         {/* -----------------------------------------------
//              COMPACT BORROWER DETAILS
//         ----------------------------------------------- */}
//         <div className="flex-grow-1">
//           {type === "lent" && isOwner && activeBorrower && (
//             <div className="bg-light p-2 rounded border border-secondary mb-1" onClick={(e) => e.stopPropagation()}>
//               <div className="d-flex justify-content-between align-items-center border-bottom pb-1 mb-1">
//                 <span className="fw-bold text-dark text-truncate" style={{ maxWidth: "100px", fontSize: "12px" }}>
//                   👤 {activeBorrower.name}
//                 </span>
//                 <a href={`tel:${activeBorrower.phone}`} className="text-decoration-none text-primary fw-bold" style={{ fontSize: "11px" }}>
//                   📞 Call
//                 </a>
//               </div>
//               <div className="mb-1">
//                 <div className="bg-white border rounded px-1 text-secondary" style={{ fontSize: "10px", height: "32px", overflowY: "auto", lineHeight: "1.1" }}>
//                   {activeBorrower.address || "No Address."}
//                 </div>
//               </div>
//               <div className="text-center fw-bold text-danger" style={{ fontSize: "11px" }}>
//                 📅 Return: {formatDate(item.borrowTo)}
//               </div>
//             </div>
//           )}
//         </div>
        
//         {/* 🔥🔥 VIEW EVIDENCE BUTTON (Added Here) 🔥🔥 */}
//          {/* Sirf Owner ya Borrower ko dikhega */}
// {(isOwner || isBorrower) && evidence.length > 0 && (
//              <button 
//                  className="btn btn-outline-info w-100 mb-2 fw-bold d-flex align-items-center justify-content-center gap-1"
//                  style={{ fontSize: "11px", padding: "4px 0" }}
//                  onClick={(e) => { e.stopPropagation(); setShowEvidenceModal(true); }}
//              >
//                  📸 View Pickup Proof
//              </button>
//         )}

//         {/* -----------------------------------------------
//              BOTTOM BUTTONS
//         ----------------------------------------------- */}
//         <div className="mt-auto pt-2 border-top w-100">

//           {/* 1. RETURN BUTTON (Only visible if NOT in court) */}
//           {type === "borrowed" && item.status !== "disputed_in_court" && court.verdict !== "guilty" && (
//             <>
//               <button className="btn btn-outline-danger btn-sm w-100 fw-bold py-0" style={{ fontSize: "12px" }} onClick={handleReturn} disabled={loading}>
//                 🔄 Return Item
//               </button>
//               <div className="text-center text-muted mt-1" style={{ fontSize: "10px" }}>Due: {formatDate(item.borrowTo)}</div>
//             </>
//           )}

//           {/* 2. EDIT BUTTON (Owner) */}
//           {isOwner && item.status === "available" && (
//             <button
//               className="btn btn-outline-primary btn-sm w-100 fw-bold"
//               onClick={(e) => { e.stopPropagation(); navigate(`/edit-item/${item._id}`); }}
//             >
//               ✏️ Edit Item
//             </button>
//           )}

//           {/* 3. 🔥 REPORT THEFT BUTTON (Only when Borrowed & No Case Yet) */}
//           {isOwner && item.status === "borrowed" && (
//             <button 
//                 className="btn btn-danger w-100 mt-2 fw-bold" 
//                 style={{fontSize: "12px"}}
//                 onClick={handleReportTheft}
//                 disabled={loading}
//             >
//               🚨 REPORT THEFT (FILE CASE)
//             </button>
//           )}

//           {/* LOCKED STATE MSG */}
//           {item.status === "disputed_in_court" && (
//              <div className="text-center text-danger fst-italic mt-1" style={{fontSize: "10px"}}>🔒 Item Locked by Admin</div>
//           )}

//         </div>

//       </div>
//     </div>

//     {/* 🔥🔥 EVIDENCE POPUP MODAL 🔥🔥 */}
//     {showEvidenceModal && (
//         <div 
//             className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
//             style={{ zIndex: 1050, background: "rgba(0,0,0,0.8)" }}
//             onClick={(e) => { e.stopPropagation(); setShowEvidenceModal(false); }}
//         >
//             <div 
//                 className="bg-white p-3 rounded shadow-lg position-relative"
//                 style={{ maxWidth: "90%", maxHeight: "90%", overflowY: "auto" }}
//                 onClick={(e) => e.stopPropagation()}
//             >
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                     <h6 className="fw-bold m-0">📸 Handover Evidence</h6>
//                     <button className="btn btn-close btn-sm" onClick={() => setShowEvidenceModal(false)}></button>
//                 </div>

//                 <div className="d-flex flex-wrap gap-2 justify-content-center">
//                     {evidence.map((imgUrl, index) => (
//                         <div key={index} className="border p-1 rounded">
//                             <img 
//                                 src={imgUrl} 
//                                 alt={`Proof ${index + 1}`} 
//                                 style={{ maxHeight: "250px", maxWidth: "100%", borderRadius: "4px" }}
//                             />
//                         </div>
//                     ))}
//                 </div>
//                 <div className="text-center mt-3">
//                     <button className="btn btn-dark btn-sm" onClick={() => setShowEvidenceModal(false)}>Close</button>
//                 </div>
//             </div>
//         </div>
//     )}
//     </>
//   );
// }

// export default MyItemCard;













//yhii se ah apna yhaa sb achha chal rha h 






 import { useNavigate } from "react-router-dom";
import { useState } from "react";

function MyItemCard({ item, type, onRefresh }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  // 🔥 Evidence Modal State
  const [showEvidenceModal, setShowEvidenceModal] = useState(false);

  /* ---------------- AUTH ---------------- */
  const user = JSON.parse(localStorage.getItem("user"));
  const myId = user?._id;
  const isOwner = item?.owner?._id === myId || item?.owner === myId;
  const isBorrower = item?.borrowedBy?._id === myId || item?.borrowedBy === myId;
  const token = localStorage.getItem("token");

  if (!item) return null;

  // 🔥 Evidence Data Extraction
  const evidence = item.pickupEvidence || item.borrow?.pickupEvidence || [];
  const activeBorrower = item.borrowedBy || item.borrower;

  /* ---------------- HELPERS ---------------- */
  const formatDateTime = (d) => {
    if (!d) return "N/A";
    return new Date(d).toLocaleString("en-GB", {
      day: 'numeric', month: 'short', 
      hour: '2-digit', minute: '2-digit', hour12: true 
    });
  };

  const coverImage =
    item.images?.find((img) => img.isCover)?.url ||
    item.images?.[0]?.url ||
    "https://via.placeholder.com/300x180";

  const court = item.adminCourt || {};
  const mandateAmt = item.mandate?.maxDeductibleAmount || item.deposit || 0;

  /* ==================================================
       ⏳ LATE STATUS (24-Hour Grace Period)
  ================================================== */
  const checkIsLate = () => {
    if (!item.borrowTo || item.status === "available") return false;
    const returnTime = new Date(item.borrowTo).getTime();
    const now = new Date().getTime();
    const gracePeriod = 24 * 60 * 60 * 1000; // 24 Ghante
    return now > (returnTime + gracePeriod);
  };

  const isLate = checkIsLate();

  /* ==================================================
       🔥 STATUS TRACKER
  ================================================== */
  const renderStatusTracker = () => {
    if (item.status === "disputed_in_court") {
      return (
        <div className="alert alert-danger p-1 mb-1 shadow-sm text-center flex-shrink-0" style={{ fontSize: "10px" }}>
          <strong>⚖️ ADMIN COURT ACTIVE</strong>
        </div>
      );
    }
    if (item.status === "stolen") {
      return (
        <div className="alert alert-success p-1 mb-1 shadow-sm text-center flex-shrink-0" style={{ fontSize: "10px" }}>
          <strong>💰 PENALTY RECOVERED</strong>
        </div>
      );
    }
    return null;
  };

  /* ==================================================
       🚨 ACTIONS
  ================================================== */
  const handleReportTheft = async (e) => {
    e.stopPropagation();
    const reason = prompt("🚨 FILE A CASE\n\nDescribe the issue:");
    if (!reason) return;
    if(!window.confirm("File case in Admin Court?")) return;

    setLoading(true);
    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/admin-court/file-case", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ itemId: item._id, reason })
      });
      const data = await res.json();
      alert(data.message || "Case Filed!");
      window.location.reload();
    } catch (error) { alert("Server Error"); }
    finally { setLoading(false); }
  };

  const handleReturn = async (e) => {
    e.stopPropagation();
    if (!window.confirm("Generate Return OTP?")) return;
    setLoading(true);
    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/return/request", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ itemId: item._id })
      });
      const data = await res.json();
      if (data.success) alert(`✅ OTP: ${data.otp}`);
      else alert(data.message);
    } catch { alert("Error"); }
    setLoading(false);
  };

  return (
    <>
    <div
      className="card shadow-sm h-100 border-0 mx-auto"
      style={{ width: "100%", maxWidth: "280px", cursor: "pointer", overflow: "hidden" }}
      onClick={() => navigate(`/items/${item._id}`)}
    >
      {/* TOP BADGES */}
      {type === "lent" && isOwner && item.status !== "available" && (
        <div className="bg-dark text-white text-center py-1 fw-bold w-100 position-absolute" style={{ zIndex: 2, fontSize: "10px" }}>📤 LENT OUT</div>
      )}
      {type === "borrowed" && !isOwner && item.status !== "available" && (
        <div className="bg-success text-white text-center py-1 fw-bold w-100 position-absolute" style={{ zIndex: 2, fontSize: "10px" }}>📥 BORROWED</div>
      )}

      {/* IMAGE */}
      <div style={{ position: "relative", height: "160px", backgroundColor: "#fff", marginTop: (item.status !== 'available' && (type === 'lent' || type === 'borrowed')) ? '22px' : '0' }}>
        <img src={coverImage} style={{ width: "100%", height: "100%", objectFit: "contain" }} alt={item.title} className="p-2" />
        {item.status === "disputed_in_court" && (
            <div className="position-absolute bottom-0 w-100 bg-danger text-white text-center small fw-bold py-1" style={{fontSize: "10px"}}>
               ⚖️ CASE ID: #{item._id.slice(-4)}
            </div>
        )}
      </div>

      <div className="card-body d-flex flex-column p-2">
        <h6 className="fw-bold text-truncate mb-1" style={{ fontSize: "14px" }}>{item.title}</h6>
        <div className="mb-2">
          <span className="badge bg-light border text-secondary" style={{ fontSize: "10px" }}>{item.category}</span>
        </div>

        {renderStatusTracker()}

        {/* -----------------------------------------------
             🕒 RENTAL STATUS DETAILS
        ----------------------------------------------- */}
        <div className="flex-grow-1">
          {item.status !== "available" && (
            <>
              {/* Case 1: Lender viewing Borrower details */}
              {isOwner && activeBorrower && (
                <div className="bg-light p-2 rounded border border-secondary mb-2">
                  <span className="fw-bold d-block mb-1" style={{fontSize: "11px"}}>👤 {activeBorrower.name} (Borrower)</span>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-danger fw-bold" style={{fontSize: "10px"}}>📅 {formatDateTime(item.borrowTo)}</span>
                    <a href={`tel:${activeBorrower.phone}`} className="text-decoration-none text-primary fw-bold" style={{fontSize: "10px"}}>📞 CALL</a>
                  </div>
                  <div className="bg-white border rounded px-1 text-secondary mt-1 mb-1" style={{ fontSize: "10px", height: "30px", overflowY: "auto", lineHeight: "1.2" }}>
                    📍 {activeBorrower.address || "No Address Provided."}
                  </div>
                </div>
              )}

              {/* Case 2: Borrower viewing Lender details */}
              {!isOwner && item.owner && (
                <div className="bg-light p-2 rounded border border-primary border-opacity-25 mb-2">
                  <span className="fw-bold d-block mb-1" style={{fontSize: "11px"}}>👤 {item.owner.name} (Owner)</span>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-danger fw-bold" style={{fontSize: "10px"}}>📅 {formatDateTime(item.borrowTo)}</span>
                    <a href={`tel:${item.owner.phone}`} className="text-decoration-none text-primary fw-bold" style={{fontSize: "10px"}}>📞 CALL</a>
                  </div>
                </div>
              )}

              {/* Late Notice (Simple) */}
              {isLate && (
                <div className="badge bg-danger w-100 mb-2 py-1" style={{fontSize: "9px"}}>🚨 OVERDUE (24h+ Passed)</div>
              )}
            </>
          )}
        </div>
        
        {/* 🔥🔥 VIEW EVIDENCE BUTTON */}
        {(isOwner || isBorrower) && evidence.length > 0 && item.status !== "available" && (
             <button 
                 className="btn btn-outline-info w-100 mb-2 fw-bold d-flex align-items-center justify-content-center gap-1"
                 style={{ fontSize: "11px", padding: "4px 0" }}
                 onClick={(e) => { e.stopPropagation(); setShowEvidenceModal(true); }}
             >
                 📸 View Pickup Proof
             </button>
        )}

        {/* -----------------------------------------------
             BOTTOM BUTTONS
        ----------------------------------------------- */}
        <div className="mt-auto pt-2 border-top w-100">
          
          {/* RETURN BUTTON */}
          {type === "borrowed" && item.status !== "available" && item.status !== "disputed_in_court" && (
            <button className="btn btn-outline-danger btn-sm w-100 fw-bold py-1" style={{ fontSize: "12px" }} onClick={handleReturn} disabled={loading}>
              🔄 Return Item
            </button>
          )}

          {/* EDIT BUTTON */}
          {isOwner && item.status === "available" && (
            <button className="btn btn-outline-primary btn-sm w-100 fw-bold" onClick={(e) => { e.stopPropagation(); navigate(`/edit-item/${item._id}`); }}>
              ✏️ Edit Item
            </button>
          )}

          {/* REPORT THEFT */}
          {isOwner && item.status === "borrowed" && (
            <button className="btn btn-danger btn-sm w-100 mt-2 fw-bold" style={{fontSize: "11px"}} onClick={handleReportTheft} disabled={loading}>
              🚨 REPORT THEFT
            </button>
          )}

          {/* LOCKED STATE */}
          {item.status === "disputed_in_court" && (
             <div className="text-center text-danger fst-italic mt-1" style={{fontSize: "10px"}}>🔒 Item Locked by Admin</div>
          )}
        </div>
      </div>
    </div>

    {/* EVIDENCE MODAL */}
    {showEvidenceModal && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 1050, background: "rgba(0,0,0,0.8)" }} onClick={() => setShowEvidenceModal(false)}>
            <div className="bg-white p-3 rounded shadow-lg position-relative" style={{ maxWidth: "90%", maxHeight: "90%", overflowY: "auto" }} onClick={(e) => e.stopPropagation()}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold m-0">📸 Handover Evidence</h6>
                    <button className="btn btn-close btn-sm" onClick={() => setShowEvidenceModal(false)}></button>
                </div>
                <div className="d-flex flex-wrap gap-2 justify-content-center">
                    {evidence.map((imgUrl, index) => (
                        <div key={index} className="border p-1 rounded">
                            <img src={imgUrl} alt="Proof" style={{ maxHeight: "250px", maxWidth: "100%", borderRadius: "4px" }} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )}
    </>
  );
}

export default MyItemCard;